import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { KeycloakService } from 'keycloak-angular';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../../contexts/settings/settings.service';
import { MediasQueryService } from 'src/app/core/services/medias-query.service';
import { LayoutUserProfileSheetComponent } from './sheet/user-profile-sheet.component';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-layout-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class LayoutUserProfileComponent implements OnInit {

  model: any = {};
  subscription: Subscription;
  realm;
  menu: Array<any> = [];

  helpCenterUrl = "";

  constructor(private keycloakService: KeycloakService, private settings: SettingsService,
    private route: ActivatedRoute,
    private mediasQueryService: MediasQueryService,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private userService: UserService
  ) { }

  async ngOnInit() {

    this.realm = this.keycloakService.getKeycloakInstance().realm;

    if (await this.keycloakService.isLoggedIn()) {

      this.route.paramMap.subscribe(params => {
        this.model.partner = params.get('partner');
        this.model.account = params.get('account');
      });



      this.model.user = this.userService.getUser();
      if (this.model.user) {
        var set = this.model.user.features?.find(p => p.key == 'settings');
        if (set) {
          var sub = set.subfeatures ? set.subfeatures : [];
          this.menu = sub.length > 0 ? this.model.user.features.find(p => p.key == 'settings').subfeatures
            .filter(p => p.configs.portal ? p.configs.portal.find(x => this.realm == 'tuna' ? x == 'tuna' : x != 'tuna') : true)
            : sub;
        }
      }

      this.subscription = this.settings.currentUser.subscribe(async user => {
        if (Object.keys(user).length > 0) {
          this.model.user = user;
        }
      });

      this.firstLetter();

      this.subscription = this.mediasQueryService.isMobile().subscribe(result => this.model.isMobile = result);

    }
  }

  async ngDoCheck() {
    this.helpCenterUrl = "https://ajuda.tuna.uy/kb/form/7493/?utm_source=console&utm_medium=user-menu&utm_campaign=" + this.router.url.split('/')[3];
  }

  async logout() {
    await this.keycloakService.logout();
  }

  firstLetter() {
    this.model.firstLetter = this.model.user ? (this.model.user.firstName ? this.model.user.firstName?.charAt(0).toUpperCase() : this.model.user.email?.charAt(0).toUpperCase()) : "";
  }

  openItems() {
    if (this.model.isMobile) {
      this.bottomSheet.open(LayoutUserProfileSheetComponent, {
        data: {
          user: this.model.user,
          partner: this.model.partner,
          account: this.model.account
        }
      });
    } else {
      this.model.open = !this.model.open;
    }
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }
}
